import { render, staticRenderFns } from "./successScreen.vue?vue&type=template&id=aa9c6e00&"
import script from "./successScreen.vue?vue&type=script&lang=js&"
export * from "./successScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports